import { AGENT_URLS } from "../../apiConfig.js";
import { STATUS_ERRORS } from "../../../common/constants/agentModule/statusConstants.js";
import apiClient from "../../apiInstance";

export const getAgentInfo = async (accessToken) => {
    try {
        if (!accessToken) {
            throw new Error("Access token is required");
        }
        const response = await apiClient.get(AGENT_URLS.GET_AGENT_NAME, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        const data = response.data;
        if (data && data.length > 0) {
            const user = data[0];
            return {
                id: user.id,
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.emailaddress,
                extension: user.extension,
                role: user.role,
                rolename: user.rolename,
                workerid: user.workerid,
            };
        } else {
            return null;
        }
    } catch (error) {
        console.error(STATUS_ERRORS.FETCH_USER_ERROR, error);
        throw error;
    }
};

export const getActiveSkills = async () => {
    try {
        const response = await apiClient.get(AGENT_URLS.GET_ACTIVE_SKILLS);
        return response.data;
    } catch (error) {
        console.error(STATUS_ERRORS.FETCH_ACTIVE_SKILLS_ERROR, error);
        throw error;
    }
};

export const getActiveReasons = async () => {
    try {
        const response = await apiClient.get(AGENT_URLS.GET_ACTIVE_REASONS);
        return response.data;
    } catch (error) {
        console.error(STATUS_ERRORS.FETCH_ACTIVE_REASONS_ERROR, error);
        throw error;
    }
};

export const handleAvailableStatus = async (agentId, selectedSkillIds) => {
    try {
        const response = await apiClient.post(AGENT_URLS.SET_AGENT_AVAILABLE, {
            agentid: agentId,
            selectedSkills: selectedSkillIds,
        });
        return response.data;
    } catch (error) {
        console.error(STATUS_ERRORS.SAVE_AVAILABLE_STATUS_ERROR, error);
        throw error;
    }
};

export const handleOfflineStatus = async (agentId, statereasonID) => {
    try {
        const response = await apiClient.post(AGENT_URLS.SET_AGENT_OFFLINE, {
            agentid: agentId,
            statereasonID,
        });
        return response.data;
    } catch (error) {
        console.error(STATUS_ERRORS.SAVE_OFFLINE_STATUS_ERROR, error);
        throw error;
    }
};

export const getAgentStatusHistory = async (agentId) => {
    try {
        const response = await apiClient.get(`${AGENT_URLS.GET_AGENT_STATUS_HISTORY}${agentId}`);
        return response.data;
    } catch (error) {
        console.error(STATUS_ERRORS.FETCH_AGENT_STATUS_HISTORY_ERROR, error);
        throw error;
    }
};

export const getAgentActiveSkills = async (agentId) => {
    try {
        const response = await apiClient.get(`${AGENT_URLS.GET_AGENT_ACTIVE_SKILLS}${agentId}`);
        return response.data;
    } catch (error) {
        console.error(STATUS_ERRORS.FETCH_AGENT_ACTIVE_SKILLS_ERROR, error);
        throw error;
    }
};

export const getAgentOfflineReason = async (agentId) => {
    try {
        const response = await apiClient.get(`${AGENT_URLS.GET_AGENT_OFFLINE_REASON}${agentId}`);
        return response.data;
    } catch (error) {
        console.error(STATUS_ERRORS.FETCH_AGENT_OFFLINE_REASON_ERROR, error);
        throw error;
    }
};

export const getAgentCurrentStatus = async (agentId) => {
    try {
        const response = await apiClient.get(`${AGENT_URLS.GET_AGENT_STATUS}${agentId}`);
        return response.data;
    } catch (error) {
        console.error(STATUS_ERRORS.FETCH_AGENT_STATUS_ERROR, error);
        throw error;
    }
};